import axios from "axios";

export default {
  actions: {
    loadIntentHistory: (context, params) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/intent-history", { params })
        .then((response) => response.data);
    },
  },
};
